import { Flex, Typography } from '@iheartjane/reefer';

interface ClarificationCellProps {
  clarification_note?: string | null;
  clarification_type?: string | null;
}

export const CLARIFICATION_LEARN_MORE_URL =
  'https://docs.iheartjane.com/partner-success/all-business-here/talk-about-product-ivity#self-publishing-options';

export const stripPrefix = (type: string) =>
  type.startsWith('clarification:')
    ? type.slice('clarification:'.length)
    : type;

export const ClarificationCell = ({
  clarification_type,
  clarification_note,
}: ClarificationCellProps) => {
  if (!clarification_type) return null;

  return (
    <Flex flexDirection="column" width={300}>
      <Typography color="error">{stripPrefix(clarification_type)}</Typography>
      {clarification_note && (
        <Typography
          color="grays-mid"
          style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}
        >
          {`"${clarification_note}"`}
        </Typography>
      )}
    </Flex>
  );
};
